module.exports = __webpack_public_path__ + "img/icon-edit.50844ee1.svg";